export default __webpack_public_path__ + "static/media/marazzi_crogiolo_lume_008.aa42de01.jpg";